import gql from 'graphql-tag'

export const ADD_POINT = gql`

mutation(
  $point:Int
  $EmployerId:ID!
){
  addPointToEmployer(info:{
    point:$point 
    EmployerId:$EmployerId
  }){
    _id
    EmployerId{
      companyName
    }
    point
  }
}


`
export const DEDUCT_POINT = gql`
mutation(
	$point:Int 
	$EmployerId:ID!
){
deductPoint(info:{
  point:$point 
  EmployerId:$EmployerId
  })
  {
  _id
    EmployerId{
      companyName
    }
    point
}
}
`